import { Component, effect, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { FRAGRANCES_LINKS } from '@banyan/commons/consts/links.const';
import { FALLBACK_LOCAL, supportedLocales } from '@banyan/commons/consts/locale.const';
import { LOCALE } from '@banyan/commons/enum/locale';
import { SimpleLink } from '@banyan/commons/models/simple-link.model';
import { AccountService } from '@banyan/modules/account/services/account.service';
import { CaptureNeedService } from '@banyan/modules/capture-needs/services/capture-need.service';
import { features } from '@banyan/modules/shared/constants/feature-toggling.const';
import { FeatureTogglingService } from '@banyan/modules/shared/services/feature-toggling/feature-toggling.service';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged, filter, map, tap } from 'rxjs';

@Component({
  selector: 'app-header-sidenav',
  templateUrl: './header-sidenav.component.html',
  styleUrls: ['./header-sidenav.component.scss'],
})
export class HeaderSidenavComponent implements OnInit {
  preferredLanguage = new FormControl<LOCALE | null>(null);
  locales = supportedLocales;
  fragranceMenuOpenState = false;
  accountMenuOpenState = false;
  fragrancesLinks: SimpleLink[] = FRAGRANCES_LINKS;
  @Output() closeSideNav = new EventEmitter();
  manageAccountLinks = [
    {
      name: 'requests',
      href: 'proposal',
      icon: 'colorize',
    },
    {
      name: 'orders',
      href: 'orders',
      icon: 'shopping_cart',
    },
    {
      name: 'edit-profil',
      href: 'profile',
      icon: 'edit',
    },
  ];
  manageAccountLinksV2 = [
    {
      name: 'requests',
      href: 'proposal/requests',
      icon: 'colorize',
    },
    {
      name: 'orders',
      href: 'orders/v2',
      icon: 'shopping_cart',
    },
    {
      name: 'edit-profil',
      href: 'profile',
      icon: 'edit',
    },
  ];
  captureNeedService = inject(CaptureNeedService);
  accountService = inject(AccountService);
  featureTogglingService = inject(FeatureTogglingService);
  translateService = inject(TranslateService);
  router = inject(Router);
  selectedLocal = FALLBACK_LOCAL;
  translateFileLoaded = false;

  constructor() {
    effect(() => {
      if (this.accountService.user().isAuthenticated) {
        this.translateService.use(this.accountService.user().preferredLanguage);
        this.preferredLanguage.patchValue(this.accountService.user().preferredLanguage, { emitEvent: false });
      }
    });
    if (this.featureTogglingService.isFeatureAllowed('EN', features)) {
      this.translateService.use(LOCALE.EN);
    } else {
      this.preferredLanguage.patchValue(FALLBACK_LOCAL, { emitEvent: false });
    }
    this.preferredLanguage.valueChanges
      .pipe(
        distinctUntilChanged(),
        filter(locale => !!locale),
        map(locale => locale as LOCALE),
        tap((locale) => {
          this.captureNeedService.languageChanged.set(true);
          this.accountService.setLocale(locale);
        }),
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.translateService.get('locales.en').subscribe(() => {
      this.translateFileLoaded = true;
    });
  }

  onToggleClose() {
    this.closeSideNav.emit(true);
  }

  logout(): void {
    this.accountService.logout();
  }

  login(): void {
    this.accountService.initAuth();
  }

  goToLink(url: string, event: any): void {
    event.stopPropagation();
    this.onToggleClose();
    this.router.navigate([url]).then();
  }
}
